import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../lib/data";

export default function Services({ compact = false }) {
    const items = compact ? SERVICES.slice(0, 8) : SERVICES;
    return (
        <section
            data-testid="services-section"
            id="services"
            className="relative py-24 md:py-32 bg-secondary/30"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
                    <div>
                        <div className="text-xs uppercase tracking-widest text-muted-foreground mb-4">
                            What we do
                        </div>
                        <h2 className="font-display font-light text-4xl md:text-5xl tracking-tighter leading-tight max-w-2xl">
                            Services built for{" "}
                            <span className="italic font-medium">
                                real businesses
                            </span>
                            .
                        </h2>
                    </div>
                    <p className="text-muted-foreground max-w-md">
                        From custom ERP and accounting platforms to mobile
                        apps, cloud and AI workflows — we cover the full
                        software stack.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
                    {items.map((s, i) => {
                        const Icon = s.icon;
                        return (
                            <motion.div
                                key={s.title}
                                initial={{ opacity: 0, y: 14 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-60px" }}
                                transition={{ delay: i * 0.04 }}
                                data-testid={`service-card-${i}`}
                                className="group relative p-6 rounded-2xl border border-border bg-card hover:bg-background transition-all duration-300 hover:-translate-y-1 hover:calm-glow"
                            >
                                <div className="w-11 h-11 rounded-xl bg-foreground/5 dark:bg-background/10 grid place-items-center mb-5 group-hover:bg-foreground group-hover:text-background transition-colors">
                                    <Icon className="h-5 w-5" />
                                </div>
                                <h3 className="font-display text-lg md:text-xl mb-2">
                                    {s.title}
                                </h3>
                                <p className="text-sm text-muted-foreground leading-relaxed">
                                    {s.desc}
                                </p>
                                <div className="overflow-hidden">
                                    <div className="mt-4 max-h-0 group-hover:max-h-32 opacity-0 group-hover:opacity-100 transition-all duration-500">
                                        <p className="text-xs text-muted-foreground/80 leading-relaxed pt-3 border-t border-border/60">
                                            {s.details}
                                        </p>
                                    </div>
                                </div>
                                <ArrowUpRight className="absolute top-5 right-5 h-4 w-4 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
